import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';
import AssetItem from '../../../../components/asset/asset-item';
import {
  AssetItemHeaderDescription,
  AssetItemHeaderChange,
} from '../../../../components/asset/asset-item/asset-item-header';
import {
  AssetItemDataText,
  AssetItemDataChange,
} from '../../../../components/asset/asset-item/asset-item-data';

import { AbbreviatedNumber, Percent } from '../../../../components/common/number';
import TableRow from '../../../../components/common/table-row';

import styles from './asset-position.styles';

class AssetPosition extends PureComponent {
  static propTypes = {
    row: PropTypes.shape({
      security: PropTypes.shape({ name: PropTypes.string }),
      quantity: PropTypes.number,
      marketValue: PropTypes.number,
      unrealisedGL: PropTypes.number,
      unrealisedGLPercent: PropTypes.number,
      proportion: PropTypes.number,
    }),
    columnWidths: PropTypes.arrayOf(PropTypes.number).isRequired,
    screen: PropTypes.shape({
      isSmall: PropTypes.bool,
    }),
  };

  static defaultProps = {
    row: {},
  };

  render() {
    const { row, columnWidths, screen } = this.props;
    const {
      security,
      quantity,
      marketValue,
      unrealisedGL,
      unrealisedGLPercent,
      proportion,
      isin,
    } = row;

    var shorten = false;
    if(screen.isSmall){
      shorten = 30;
    }

    return (
      <AssetItem>
      {
        screen.isSmall &&
        <View>
        <TableRow style={styles.topRow}>
          <TableRow.Column
            align="left"
            width={columnWidths[0] + columnWidths[1]}
            testID="description"
          >
            <AssetItemHeaderDescription
              row={{
                description: security,
              }}
              shorten={shorten}
            />
          </TableRow.Column>
          <TableRow.Column width={columnWidths[2]}>
            <AssetItemHeaderChange value={unrealisedGLPercent} />
          </TableRow.Column>
        </TableRow>

        <TableRow style={styles.bottomRow}>
          <TableRow.Column
            align="left"
            width={columnWidths[0]}
          >
            <AbbreviatedNumber
              renderProps={{ size: 'large' }}
              maxDigits={6}
              maxDecimals={4}
              maxDigitsIncludeDecimals={true}
              value={quantity}
            />
          </TableRow.Column>
          <TableRow.Column width={columnWidths[1]}>
            <AssetItemDataText value={marketValue} />
          </TableRow.Column>
          <TableRow.Column width={columnWidths[2]}>
            <AssetItemDataChange value={unrealisedGL} />
          </TableRow.Column>
        </TableRow>
        </View>
      }
        {
          !screen.isSmall &&
          <View>
          <TableRow style={styles.topRow}>
            <TableRow.Column
              align="left"
              width={1}
              testID="description"
            >
              <AssetItemHeaderDescription
                row={{
                  description: security,
                }}
              />
            </TableRow.Column>
          </TableRow>
          <TableRow style={styles.bottomRow}>
            <TableRow.Column
              align="left"
              width={columnWidths[0]}
            >
              <AbbreviatedNumber
                renderProps={{ size: 'large' }}
                maxDigits={6}
                maxDecimals={4}
                maxDigitsIncludeDecimals={true}
                value={quantity}
              />
            </TableRow.Column>
            <TableRow.Column width={columnWidths[1]}>
              <AssetItemDataText value={marketValue} />
            </TableRow.Column>
            <TableRow.Column width={columnWidths[2]}>
              <AssetItemDataChange value={unrealisedGL} />
            </TableRow.Column>
            <TableRow.Column width={columnWidths[3]}>
              <AssetItemHeaderChange value={unrealisedGLPercent} />
            </TableRow.Column>
            <TableRow.Column width={columnWidths[4]}>
              <Percent value={proportion}/>
            </TableRow.Column>
          </TableRow>
          </View>
      }
      </AssetItem>
    );
  }
}

export default AssetPosition;
